import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import {Container} from "@mui/material";
import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import {isValidPhoneNumber} from 'libphonenumber-js';
import {Snackbar, Alert, AlertTitle} from '@mui/material';


const Profile = () => {

    const token = localStorage.getItem('token');

    const [anchorEl, setAnchorEl] = useState(null);
    const [user, setUser] = useState({"Email": "", "FirstName": "", "LastName": "", "Password": "", "Phone": ""});
    const [emailError, setEmailError] = useState(false);
    const [emailHelperText, setEmailHelperText] = useState('');
    const [firstNameError, setFirstNameError] = useState(false);
    const [firstNameHelperText, setFirstNameHelperText] = useState('');
    const [lastNameError, setLastNameError] = useState(false);
    const [lastNameHelperText, setLastNameHelperText] = useState('');
    const [phoneError, setPhoneError] = useState(false);
    const [phoneHelperText, setPhoneHelperText] = useState('');
    const [passwordError, setPasswordError] = useState(false);
    const [passwordHelperText, setPasswordHelperText] = useState('');
    const [alertInfo, setAlertInfo] = useState({open: false, message: '', severity: 'success'});
    const navigate = useNavigate();

    const open = Boolean(anchorEl);

    const isAdmin = localStorage.getItem('x') === "1";

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleMenuClose = () => {
        setAnchorEl(null);
    }

    const handleMenuLogout = () => {
        handleMenuClose();
        localStorage.setItem('token', "");
        localStorage.setItem('email', "");
        localStorage.setItem('x', "");
        navigate('/');
    }

    const handleMenuSearch = () => {
        handleMenuClose();
        navigate('/landing')
    }

    const handleMenuAbout = () => {
        handleMenuClose();
        navigate("/about")
    }

    const handleMenuAdvancedSearch= () => {
        handleMenuClose();
        navigate('/advancedSearch')
    }

    const handleMenuUserManagement = () => {
        handleMenuClose();
        navigate("/userManagement")
    }

    const handleEmailChange = (e) => {
        setUser(prevUser => ({
            ...prevUser,
            Email: e.target.value,
        }));
    }

    const handleFirstNameChange = (e) => {
        setUser(prevUser => ({
            ...prevUser,
            FirstName: e.target.value,
        }));
    }

    const handleLastNameChange = (e) => {
        setUser(prevUser => ({
            ...prevUser,
            LastName: e.target.value,
        }));
    }

    const handlePhoneChange = (e) => {
        setUser(prevUser => ({
            ...prevUser,
            Phone: e.target.value,
        }));
    }

    const handlePasswordChange = (e) => {
        setUser(prevUser => ({
            ...prevUser,
            Password: e.target.value,
        }));
    }

    const handleAlertClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlertInfo({ ...alertInfo, open: false });
    };

    const retrieveProfile = async ()  => {
        try {
            const response  = await fetch(`/api/getProfile`,{
                method: 'GET',
                headers: {'Authorization': 'Bearer ' + token}
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const json = await response.json();
            console.log('User data', json);
            json['Password'] = "";
            setUser(json);
        } catch (err) {
            console.error(err);
        }
    }

    const handleUpdateProfile = () => {
        //console.log("Adding User...");
        var errors = false;

        if (validateEmail(user.Email)) {
            setEmailError(false);
            setEmailHelperText('');
            // Proceed with form submission logic (e.g., API call)
        } else {
            setEmailError(true);
            setEmailHelperText('Please enter a valid email address');
            errors = true;
        }
        if ( user.FirstName === '') {
            setFirstNameError(true);
            setFirstNameHelperText('First Name is required');
            errors = true;
        }
        if ( user.LastName === '') {
            setLastNameError(true);
            setLastNameHelperText('Last Name is required');
            errors = true;
        }
        if (validatePhone(user.Phone)) {
            setPhoneError(false);
            setPhoneHelperText('');
        } else {
            setPhoneError(true);
            setPhoneHelperText('Valid Phone Number is required');
            errors = true;
        }
        var passwordValidation = validatePassword(user.Password)
        console.log("PasswordValidation: " + passwordValidation)
        if (passwordValidation === '') {
            setPasswordError(false);
            setPasswordHelperText('');
        } else {
            setPasswordError(true);
            setPasswordHelperText(passwordValidation);
            errors = true;
        }
        if (!errors) {
            updateProfile(user);
        }
    }

    const updateProfile = async (user) => {
        console.log('Modifying user');
        try {
            const response = await fetch('/api/updateProfile', {
                method: 'POST',
                headers: {'Authorization': 'Bearer ' + token},
                body: JSON.stringify(user),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const json = await response.json();
            console.log('Response: ', json);
            setAlertInfo({
                open: true,
                message: `Success: Profile saved successfully!`,
                severity: 'success',
            });
        } catch (err) {
            console.error(err);
            setAlertInfo({
                open: true,
                message: `Error: ${err.message}`,
                severity: 'error',
            });
        }
    }

    const validateEmail = (email) => {
        // A simple regex for email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    const validatePassword = (password) => {
        if (password === "") {
            return '';
        }
        const minLength = 8;
        const hasUpperCase = /[A-Z]/.test(password);
        const hasLowerCase = /[a-z]/.test(password);
        const hasNumbers = /\d/.test(password);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

        if (password.length < minLength) {
            return 'Password length must be at least 8 characters';
        }
        if (!hasUpperCase) {
            return 'Password must include an upper case character';
        }
        if (!hasLowerCase) {
            return 'Password must include an lower case character';
        }
        if (!hasNumbers) {
            return 'Password must include a number character';
        }
        if (!hasSpecialChar) {
            return 'Password must include a special character: !@#$^&*(),.?":{}|<>';
        }
        return '';
    }

    const validatePhone = (phoneNo) => {
        return isValidPhoneNumber(phoneNo);
    }

    useEffect(() => {
        retrieveProfile()
    }, []);
    return (
        <Container component="main" maxWidth="lg">
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="static">
                    <Toolbar>
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2 }}
                            aria-haspopup="true"
                            aria-controls={open ? 'popup-menu' : undefined}
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleMenuClick}
                        >
                            <MenuIcon />
                        </IconButton>
                        {/* The actual MUI Menu component */}
                        <Menu
                            id="popup-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleMenuClose}
                            // Keep the menu mounted in the DOM when closed for potential performance benefits
                            // You can remove keepMounted if you prefer it to unmount
                            keepMounted
                            MenuListProps={{
                                'aria-labelledby': 'menu-button',
                            }}
                        >
                            {/* Menu Items */}
                            <MenuItem onClick={handleMenuAbout}>
                                <Typography variant="inherit">About</Typography>
                            </MenuItem>
                            <MenuItem onClick={handleMenuSearch}>
                                <Typography variant="inherit">Search</Typography>
                            </MenuItem>
                            <MenuItem onClick={handleMenuAdvancedSearch} >
                                <Typography variant="inherit">Advanced Search</Typography>
                            </MenuItem>
                            {isAdmin && <MenuItem onClick={handleMenuUserManagement}><Typography variant="inherit">User Management</Typography></MenuItem>}
                            <MenuItem onClick={handleMenuLogout}>
                                <Typography variant="inherit">Logout</Typography>
                            </MenuItem>
                        </Menu>

                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                            Profile
                        </Typography>
                    </Toolbar>
                </AppBar>
            </Box>
            <Paper sx={{ flexGrow: 1, width: '100%', padding: 4, marginTop: 2}}>
                <Grid container spacing={2}>
                    <Grid size={4}>
                        <TextField
                            id="email"
                            label="Email"
                            variant="outlined"
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            fullWidth
                            value={user.Email}
                            onChange={handleEmailChange}
                            error={emailError}
                            helperText={emailHelperText}
                            type="email"
                        />
                    </Grid>
                    <Grid size={4}>
                        <TextField
                            id="firstName"
                            label="First Name"
                            variant="outlined"
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            fullWidth
                            value={user.FirstName}
                            onChange={handleFirstNameChange}
                            error={firstNameError}
                            helperText={firstNameHelperText}
                            type="text"
                        />
                    </Grid>
                    <Grid size={4}>
                        <TextField
                            id="lastName"
                            label="Last Name"
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            fullWidth
                            value={user.LastName}
                            onChange={handleLastNameChange}
                            error={lastNameError}
                            helperText={lastNameHelperText}
                            type="text"
                        />
                    </Grid>
                    <Grid size={4}>
                        <TextField
                            id="password"
                            label="Password"
                            variant="outlined"
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            fullWidth
                            value={user.Password}
                            onChange={handlePasswordChange}
                            error={passwordError}
                            helperText={passwordHelperText}
                            type="text"
                        />
                    </Grid>
                    <Grid size={4}>
                        <TextField
                            id="phone"
                            label="Phone"
                            variant="outlined"
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            fullWidth
                            value={user.Phone}
                            onChange={handlePhoneChange}
                            error={phoneError}
                            helperText={phoneHelperText}
                            type="text"
                        />
                    </Grid>
                    <Grid size={9}>
                        <Typography variant="body1">
                            If you leave the Password field empty, your password will remain unchanged.
                        </Typography>
                    </Grid>
                    <Grid size={3}>
                        <Button variant="contained" onClick={handleUpdateProfile}>Modify Profile</Button>
                    </Grid>
                </Grid>
                {/* Snackbar component manages positioning and auto-hide duration */}
                <Snackbar
                    open={alertInfo.open}
                    autoHideDuration={6000} // Alert disappears after 6 seconds
                    onClose={handleAlertClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                >
                    {/* Alert component housed within the Snackbar */}
                    <Alert
                        onClose={handleAlertClose}
                        severity={alertInfo.severity}
                        variant="filled" // Optional: gives a filled background look
                        sx={{ width: '100%' }}
                    >
                        <AlertTitle>{alertInfo.severity === 'success' ? 'Success' : 'Error'}</AlertTitle>
                        {alertInfo.message}
                    </Alert>
                </Snackbar>
            </Paper>
        </Container>

    );
};

export default Profile;